import { Text } from '@/shared/components/typography'

function CancelModalTitle({ title }: { title: string }) {
  return (
    <div className="mt-6 px-2">
      <Text level="text1" color="text090" weight="medium">
        {title}
      </Text>
    </div>
  )
}

export default CancelModalTitle
